import { useParams } from 'react-router-dom'
import ConfirmationPage from 'shop/pages/Order'
import { AppContentLoader, LoaderSwitcher } from 'router/loaders'

export const ConfirmationWrapper = () => {
  const { cart_id, payment_id } = useParams<{
    cart_id: string
    payment_id: string
  }>()

  return (
    <AppContentLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <ConfirmationPage
            entityId={cart_id}
            paymentId={payment_id}
            mode='cart'
          />
        </LoaderSwitcher>
      )}
    </AppContentLoader>
  )
}
